<template>
  <div class="main">
    <div>
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="false"
        :pdf-quality="2"
        :manual-pagination="true"
        pdf-format="a4"
        pdf-orientation="portrait"
        ref="html2Pdf"

        :html-to-pdf-options="{
          filename : 'Pedido Rápido - Qr Code',
          html2canvas: {
              scrollY: 0,
              width: 1550
            }
          }"
        
        @progress="onProgress($event)"
        @hasPaginated="hasPaginated()"
        @hasDownloaded="hasDownloaded($event)"
    >
        <section slot="pdf-content" class="pdf-content">
          <div style="position: relative">
            <div class="qr-code-printable image" ref="qrcode_print"></div>
            <div class="qr-code-printable table-number" :style="`color: ${color}`"> MESA {{ String(table.number).padStart(2, '0') }} </div>
            <div class="qr-code-printable short-url" :style="`color: ${color}`"> {{ shortUrlId }} </div>
            <svg-smartphone :color="color" style="scale(0.6)" class="qr-code-printable cellphone" />
          </div>
        </section>
      </vue-html2pdf>
    </div>

    <div>
      <div style="position: relative">
        <svg-smartphone :color="color" style="width: 50%; heigth: 50%" />
        <div class="qr-code-preview image" ref="qrcode_preview"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as qrCode from 'easyqrcodejs'
  import VueHtml2pdf from 'vue-html2pdf'
  import SvgSmartphone from './SvgSmartphone.vue'
  import downloadQrCode from '../downloadQrCode'

  export default {
    name: 'Two',
    props:{
      includeLogo: {
        required: true,
        type: Number,
        default: 1,
      },
      table: {
        required: false,
        type: Object,
      },
      preview: {
        required: false,
        type: Boolean,
      },
      color: {
        required: false,
        type: String,
      },
    },
    
    mixins: [downloadQrCode(570, 570)],

    components : {
      VueHtml2pdf,
      SvgSmartphone,
      'qr-code' : qrCode
    },

    data() {
      return {
        qrCodePreview: null,
        qrCodePrintDrawn: '',
        shortUrlId: '',
        customerLogo: '',
      }
    },

    mounted() {
      if(!Object.keys(this.table).length) return
      this.shortUrlId = this.table.shortUrl.substring(this.table.shortUrl.length - 6, this.table.shortUrl.length);
      this.generateQrCodePreview()
    },

    methods: {
      generateQrCodePreview() {
        this.qrCodePreview = new qrCode(this.$refs.qrcode_preview, {
          text: this.table.shortUrl,
          width: 105,
          height: 105,
          quietZone: 0,
          quietZoneColor: 'transparent',
        })
      },

      onProgress (e) {
        if(e < 100) {
          this.$emit('downloading', true)
        }
      },

      hasPaginated () {
        console.log('hasPaginated')
        this.$emit('hasPaginated')
      },

      hasDownloaded () {
        console.log('download finalizado')
        this.$emit('downloaded', true)
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import './css/main.scss';
</style>